"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "Accordion", {
    enumerable: true,
    get: function() {
        return Accordion;
    }
});
var _react = _interop_require_default(require("react"));
var _react1 = require("@chakra-ui/react");
var _Icons = require("../../media/Icons/index");
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var Accordion = function(props) {
    return _react.default.createElement(_react1.Accordion, props);
};
var AccordionButton = function(_param) {
    var highlight = _param.highlight, props = _object_without_properties(_param, [
        "highlight"
    ]);
    return _react.default.createElement(_react1.AccordionButton, _object_spread({
        _expanded: highlight && {
            bg: "background-action-active"
        }
    }, props));
};
var AccordionIcon = function(props) {
    var _useAccordionItemState = (0, _react1.useAccordionItemState)(), isOpen = _useAccordionItemState.isOpen, isDisabled = _useAccordionItemState.isDisabled;
    var reduceMotion = (0, _react1.useAccordionContext)().reduceMotion;
    var styles = (0, _react1.useAccordionStyles)();
    var iconStyles = _object_spread({
        opacity: isDisabled ? 0.4 : 1,
        transform: isOpen ? "rotate(-180deg)" : undefined,
        transition: reduceMotion ? undefined : "transform 0.2s",
        transformOrigin: "center"
    }, styles.icon);
    return _react.default.createElement(_Icons.IconChevronDown, _object_spread({}, iconStyles, props));
};
Accordion.Item = _react1.AccordionItem;
Accordion.Button = AccordionButton;
Accordion.Panel = _react1.AccordionPanel;
Accordion.Icon = AccordionIcon;
